"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = require("react");
const lodash_es_1 = require("lodash-es");
function useDebounceEvent({ delay = 0, onChange, initialStateValue = "", trim }) {
    const [inputValue, setValue] = (0, react_1.useState)(initialStateValue);
    const previousValue = (0, react_1.useRef)(null);
    (0, react_1.useEffect)(() => {
        previousValue.current = initialStateValue;
    });
    const debounceCallback = (0, react_1.useMemo)(() => {
        if (!delay) {
            return onChange;
        }
        if (!onChange) {
            return lodash_es_1.noop;
        }
        return (0, lodash_es_1.debounce)(onChange, delay);
    }, [onChange, delay]);
    const onEventChanged = (0, react_1.useCallback)((event) => {
        const { value } = event.target;
        const finalValue = trim ? value.trim() : value;
        setValue(finalValue);
        debounceCallback(finalValue);
    }, [debounceCallback, setValue, trim]);
    const clearValue = (0, react_1.useCallback)(() => {
        setValue("");
        if (onChange) {
            onChange("");
        }
    }, [setValue, onChange]);
    if (initialStateValue !== previousValue.current && initialStateValue !== inputValue) {
        setValue(initialStateValue);
    }
    return { inputValue, onEventChanged, clearValue, updateValue: setValue };
}
exports.default = useDebounceEvent;
